import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { selectProduct } from "../../Store/Catalog/Actions";
import Utilities from "../../Helpers/Utilities";

class RelatedProducts extends Component {
    constructor(props) {
        super(props);

        this.imageClick = this.imageClick.bind(this);
        this.trimPrice = this.trimPrice.bind(this);
    }

    imageClick(product) {
        const { product: originalProduct, config: { KITS_CATEGORY_ID, DEVICES_CATEGORY_ID, PANASONIC_ACCESSORIES_CATEGORY_ID, PANASONIC_T1_ACCESSORIES_CATEGORY_ID, ZEBRA_ACCESSORIES_CATEGORY_ID, ZEBRA_TC26_ACCESSORIES_CATEGORY_ID, ZEBRA_TC58_ACCESSORIES_CATEGORY_ID, ZEBRA_TC78_ACCESSORIES_CATEGORY_ID, SAMSUNG_ACCESSORIES_CATEGORY_ID, UNIVERSAL_ACCESSORIES_CATEGORY_ID, RENTALS_CATEGORY_ID } } = this.props;

        const originalProductCategoryId = originalProduct.category.id;

        let path;
        switch (originalProductCategoryId) {
        case DEVICES_CATEGORY_ID:
            path = "devices";
            break;
        case PANASONIC_ACCESSORIES_CATEGORY_ID:
            path = "accessories-panasonic";
            break;
        case PANASONIC_T1_ACCESSORIES_CATEGORY_ID:
            path = "panasonic-t1-accessories";
            break;
        case ZEBRA_ACCESSORIES_CATEGORY_ID:
            path = "accessories-zebra";
            break;
        case ZEBRA_TC26_ACCESSORIES_CATEGORY_ID:
            path = "accessories-tc26";
            break;
        case ZEBRA_TC58_ACCESSORIES_CATEGORY_ID:
            path = "zebra-tc58-accessories";
            break;
        case ZEBRA_TC78_ACCESSORIES_CATEGORY_ID:
            path = "zebra-tc78-accessories";
            break;
        case SAMSUNG_ACCESSORIES_CATEGORY_ID:
            path = "accessories-samsung";
            break;
        case UNIVERSAL_ACCESSORIES_CATEGORY_ID:
            path = "accessories-universal";
            break;
        case KITS_CATEGORY_ID:
            path = "kits";
            break;
        case RENTALS_CATEGORY_ID:
            path = "rentals";
            break;
        }

        Utilities.scrollToTop(true);
        this.props.selectProduct(product);

        this.props.history.push(`/${path}/details?product=${product.id}`);
    }

    // take out the "incl tax" from price value
    trimPrice(longPrice) {
        let shortPrice = longPrice.replace(/ .*/, "");
        return shortPrice;
    }

    render() {
        const { selectedProduct } = this.props;

        if (selectedProduct.relatedProducts && selectedProduct.relatedProducts.length > 0) {
            return _.map(selectedProduct.relatedProducts, product =>
                <div className="col-md-4" key={product.id}>
                    <div className="product">
                        <a>
                            <img alt="Image" src={product.defaultPictureModel.fullSizeImageUrl} onClick={() => {
                                this.imageClick(product);
                            }} />
                        </a>
                        <a className="block">
                            <div>
                                <h5>{product.name}</h5>
                            </div>
                            <div>
                                <span className="h4 inline-block">{product.productPrice.price}</span>
                            </div>
                        </a>
                    </div>
                </div>
            );
        }

        return "";
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        selectedProduct: state.selectedProduct
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectProduct: selectProduct
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RelatedProducts));
